import {
  isMobile, isMockModeEnabled,
  showErrorToast,
  showSuccessToast, sleep
} from "../helpers";
import {hideOverlay, showOverlay} from "../blocks";
import {openModal} from "../components/modal";
import {
  getChatId, getHasDraftChat, deleteMrBrainChatById, getHistoryChatList,
  resetSessionState
} from "./api";
import {stopRecordingUI} from "./mic";
import {mockedhistoryArray} from "./mock";
import {
  appendChatError,
  clearChatUI,
  focusTextInput,
  loadSelectedChat,
  openDraftChat,
  replaceDraftHtml
} from "./chat-container";
import {appendTooltip, initTooltip} from "../components/tooltip";

export function initSidebarHistory() {
  const $sidebarMobile = jQuery('#history-sidebar-mobile');
  const $newChatButton = jQuery('#new-chat , #new-chat-mobile');

  //popolo cronologia chat
  refreshChatHistory();

  $newChatButton.on('click', function() {
    openDraftChat();
  });


  jQuery('#toggle-history-sidebar').on('click', function(e) {
    e.stopPropagation();
    toggleHistoryMobile(true);
  });

  // Toggle Chiusura Mobile
  jQuery('#close-history-mobile, #new-chat-mobile').on('click', function() {
    toggleHistoryMobile(false);
  });

  jQuery('#overlay').on('click', function () {
    //chiusura sull'overlay se sidebar aperta
    if (!$sidebarMobile.hasClass('-translate-x-full')) {
      toggleHistoryMobile(false);
    }
  });


  //carica la chat specifica
  jQuery('#history-list, #history-list-mobile').on('click', 'li', function(ev) {
    if (jQuery(ev.target).closest('.open-menu-btn, .chat-actions-menu').length) return;
    const chatId = jQuery(this).data('chat-id');
    const DRAFT_CHAT_ID = '__DRAFT__';
    jQuery('#history-list li, #history-list-mobile li').removeClass('text-pink-400 font-semibold');
    jQuery(this).addClass('text-pink-400 font-semibold');
    if (chatId !== DRAFT_CHAT_ID) {
      loadSelectedChat(chatId);
    }
    if (isMobile()) toggleHistoryMobile(false);
  });

  //Gestione apertura menu (mobile + desktop)
  jQuery('#history-list, #history-list-mobile').on('click', '.open-menu-btn', function (e) {

    e.stopPropagation();
    const $btn = jQuery(this);
    const $li = jQuery(this).closest('li');
    const $menu = $li.find('.chat-actions-menu');
    const isCurrentlyOpen = !$menu.hasClass('hidden');

    // verifico se ha titolo su due righe per applicare dinamicamente transform al menu
    const $title = jQuery(this).siblings(".history-item-title");
    const hasTwoLinesTitle = $title.height() > 20
    console.log($title, hasTwoLinesTitle)
    if (hasTwoLinesTitle) $menu.addClass("two-lines-title")

    // verifico a che altezza è stato fatto il click. se è nel 20% inferiore dello schermo, sposto tendina menu in alto
    const windowHeight = window.innerHeight;
    const clickY = e.clientY;
    const bottomThreshold = windowHeight * 0.8;

    if (clickY >= bottomThreshold) {
      $menu.addClass("upper-position")
    }


    jQuery('.chat-actions-menu').addClass('hidden');
    jQuery('#history-list li, #history-list-mobile li').removeClass('is-open');
    jQuery('.open-menu-btn img').attr('src', '/themes/custom/adoption_management/assets/icons/history-chat-action.svg');

    if (!isCurrentlyOpen) {
      //Apri
      $btn.find('img').attr('src', '/themes/custom/adoption_management/assets/icons/clicked-action-button.svg');
      $menu.removeClass('hidden');
      $li.addClass('is-open');
    }


  });


  //Gestione Elimina nel menu (desktop + mobile)
  jQuery('#history-list, #history-list-mobile').on('click', '.delete-chat-btn', function(e) {
    e.stopPropagation();
    const chatId = jQuery(this).data('chat-id');
    const chatSummary = jQuery(this).data('summary');
    const $row = jQuery(this).closest('li');
    jQuery('.chat-actions-menu').addClass('hidden');
    openMrBrainConfirmDeleteChatModal(chatId, $row, chatSummary);
  });

  //Chiusura Menu (desktop + mobile)
  jQuery(document).on('click', function () {
    //Ripristina bottone
    jQuery('#history-list li.is-open .open-menu-btn img, #history-list-mobile li.is-open .open-menu-btn img')
      .attr('src', '/themes/custom/adoption_management/assets/icons/history-chat-action.svg');
    jQuery('.chat-actions-menu').addClass('hidden');
    jQuery('#history-list li, #history-list-mobile li').removeClass('is-open');
  });
}

export function toggleHistoryMobile(show = true) {
  const $sidebar = jQuery('#history-sidebar-mobile');
  if (show) {
    showOverlay();
    $sidebar.removeClass('-translate-x-full');
  } else {
    hideOverlay();
    $sidebar.addClass('-translate-x-full');
  }
}

function openMrBrainConfirmDeleteChatModal(chatId , $row, chatSummary) {
  // Configuro la modale
  openModal({
    header: `Vuoi davvero eliminare ${chatSummary}?`,
    body: 'L\'azione non è reversibile.',
    confirm_label: 'Elimina Chat',
    cancel_label: 'Annulla',
    loading: true,
    loading_label: 'Eliminazione in corso...',
    confirm_callback: async () => {
      try {

        //controllo se sto eliminando la chat attualmente aperta
        const isDeletingCurrentChat = chatId == getChatId();

        if (!isMockModeEnabled) await deleteMrBrainChatById(chatId);

        //se ho eliminato la chat corrente, apro una nuova draft
        if (isDeletingCurrentChat) {
          // Reset della sessione
          resetSessionState()

          // Pulisco l'UI e mostro il messaggio intro
          clearChatUI();
          jQuery('.intro-message').fadeIn();
          jQuery('#chatbot-input').val('');
          focusTextInput();
          prependDraftChatToHistory();
        }

        $row.remove();
        showSuccessToast("Chat eliminata correttamente");
        stopRecordingUI();
      } catch (error) {
        console.error("Errore durante l'eliminazione:", error);
        showErrorToast("Errore durante l'eliminazione della chat");
      }
    },
    //non necessito di azioni all'annullamento
    cancel_callback: null
  });
}

export async function updateNewChatTitle(chatId) {
  let chats
  if (isMockModeEnabled) {
    chats = mockedhistoryArray
  } else {
    chats = await getHistoryChatList();
  }
  const filteredChats = chats.filter(c => c.chat_id === chatId + "")
  if (filteredChats.length > 0) {
    replaceDraftHtml(chatId , filteredChats[0].summary);
    selectChatInHistory(chatId);
  }
}

//funzione per caricare la cronologia delle chat
export async function refreshChatHistory() {
  try {
    const $container = jQuery('#history-list, #history-list-mobile');

    //svuoto la lista
    $container.empty();

    //spinner
    $container.append(`
      <div id="fetching-spinner" class="flex items-center gap-1 py-3">
        <div id="spinner" class="flex items-center">
          <div class="loader-history"></div>
        </div>
        <span class="text-base">Carico le ultime chat...</span>
      </div>
    `);

    let history = null;

    if (isMockModeEnabled) {
      await sleep(2000);
      history = mockedhistoryArray
    } else {
      history = await getHistoryChatList();
    }

    $container.find('#fetching-spinner').remove();

    //riappende la draft
    if (getHasDraftChat()) {
      prependDraftChatToHistory();
    }


    history.forEach(chat => {
      const chatHtml = generateHistoryItem(chat.summary, chat.chat_id);
      $container.append(chatHtml);
      // const $item = jQuery(`li[data-chat-id="${chat.chat_id}"]`)
      // appendTooltip($item, $item.find(".history-item-title").first().text())
    });
  } catch (error) {
    console.error("Errore nel popolare la cronologia:", error);
    const $container = jQuery('#history-list, #history-list-mobile');
    $container.empty();
    appendChatError('Si è verificato un errore. Aggiornare la pagina e riprovare');
  }
}

export function generateHistoryItem(summary, chat_id) {
  return `
        <li class="group relative flex items-center py-3 cursor-pointer transition-all group-[.is-open]:bg-gray-50" data-chat-id="${chat_id}">

            <span id="tooltip-trigger-${chat_id}" class="history-item-title sidebar-item-title line-clamp-2 pr-12">${summary}</span>

            <button class="open-menu-btn absolute right-0 p-1 rounded-md transition-all
                lg:opacity-0 lg:group-hover:opacity-100
                group-[.is-open]:opacity-100
                group-[.is-open]:bg-gray-200
                hover:bg-gray-200">
                <img src="/themes/custom/adoption_management/assets/icons/history-chat-action.svg" alt="azioni" class="size-8"/>
            </button>

            <div class="chat-actions-menu hidden absolute top-12 right-0 bg-white border border-gray-200 rounded-lg shadow-sm z-[100] w-full">
                <div class="px-3 py-2 text-[12px] font-semibold text-gray-400 tracking-wider">Azioni</div>
                <button
                    data-chat-id="${chat_id}"
                    data-summary="${summary}"
                    class="delete-chat-btn w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center rounded-b-lg"
                >
                    Elimina
                </button>
            </div>
        </li>
    `
}

//seleziona la chat nella history
export function selectChatInHistory(chatId) {
  if (!chatId) return;

  const $items = jQuery('#history-list li, #history-list-mobile li');
  $items.removeClass('text-pink-400 font-semibold');

  const $target = $items.filter(`[data-chat-id="${chatId}"]`);
  if ($target.length) {
    $target.addClass('text-pink-400 font-semibold');
  }
}


//gestione della new Chat per la sezione cronologia
export function prependDraftChatToHistory() {
  const DRAFT_CHAT_ID = '__DRAFT__';
  const $container = jQuery('#history-list, #history-list-mobile');

  //rimuovo eventuale draft precedente
  $container.find(`[data-chat-id="${DRAFT_CHAT_ID}"]`).remove();

  jQuery('#history-list li, #history-list-mobile li')
    .removeClass('text-pink-400 font-semibold');

  const html = `
    <li data-chat-id="${DRAFT_CHAT_ID}"
        class="text-pink-400 font-semibold py-2">
      <span class="sidebar-item-title">Nuova chat</span>
    </li>
  `;

  $container.prepend(html);
}
